import React from 'react';
import times from 'lodash/times';

let PeopleIcons = (props) => {
	return (
		<div className="people-icons">
			{times(props.adults, (i) => <img src="img/adult.png" key={'adult' + i} />)}
			{times(props.children, (j) => <img src="img/child.png" key={'child' + j} />)}
		</div>
	);
}

export default PeopleIcons;



/** WEBPACK FOOTER **
 ** ../ibe/desktop/PeopleIcons.js
 **/